export const translations = {
  en: {
    // Header
    home: 'Home',
    about: 'About Us',
    products: 'Products',
    contact: 'Contact',
    
    // Hero
    companyName: 'AL HANADIS',
    tagline: 'Quality and Excellence in Every Bite',
    heroDescription: 'Importing the freshest fruits from around the world to Iraq since 2023',
    getInTouch: 'Get In Touch',
    
    // About
    aboutTitle: 'About AL HANADIS',
    aboutDescription: 'Welcome to Al Hanadis, a leading importer of premium fruits from around the globe. Based in Iraq, we specialize in bringing the freshest and highest-quality fruits to local markets. Our mission is to provide our customers with a diverse range of exotic and delicious fruits, ensuring top-notch quality and freshness. Looking ahead, we are excited to expand our horizons and share our exceptional fruits with international markets, including Europe and the Arabian Gulf. At Al Hanadis, we are committed to quality, sustainability, and excellence in every step of our journey.',
    
    // Features
    globalSourcing: 'Global Sourcing',
    globalSourcingDesc: 'We import fruits from the best regions around the world, ensuring quality and freshness.',
    seasonalVariety: 'Seasonal Variety',
    seasonalVarietyDesc: 'Our product selection adapts to seasons, bringing you the freshest fruits year-round.',
    qualityAssured: 'Quality Assured',
    qualityAssuredDesc: 'Every fruit is carefully inspected and stored in optimal conditions to maintain freshness.',
    reliableDistribution: 'Reliable Distribution',
    reliableDistributionDesc: 'With years of experience, we ensure timely delivery and excellent service to our customers.',
    
    // Products
    productsTitle: 'Our Premium Products',
    productsDescription: 'We source seasonal fruits from the finest regions worldwide, ensuring exceptional quality and freshness in every delivery.',
    freshStrawberries: 'Fresh Strawberries',
    strawberriesDesc: 'Premium quality strawberries, carefully selected and imported fresh.',
    goldenApples: 'Golden Apples',
    goldenApplesDesc: 'Sweet and crisp golden apples, sourced from the finest orchards worldwide.',
    peachesApricots: 'Peaches & Apricots',
    peachesDesc: 'Juicy peaches and apricots, perfect for the season, stored with care.',
    redApples: 'Premium Red Apples',
    redApplesDesc: 'High-quality red apples, carefully packed and stored in optimal conditions.',
    greenGrapes: 'Fresh Green Grapes',
    grapesDesc: 'Sweet green grapes, expertly packaged and ready for distribution.',
    premiumMangoes: 'Premium Golden Mangoes',
    premiumMangoesDesc: 'Sweet and juicy golden mangoes, carefully selected and individually wrapped for premium quality.',
    seasonalSelection: 'Seasonal Selection',
    seasonalInfo: 'Our product range varies with the seasons to bring you the freshest fruits at their peak. We continuously update our inventory based on seasonal availability and quality standards.',
    
    // Categories
    berries: 'Berries',
    apples: 'Apples',
    stoneFruits: 'Stone Fruits',
    grapes: 'Grapes',
    
    // Contact
    contactTitle: 'Get In Touch',
    contactDescription: "Contact us today for premium quality fruits. We're here to serve you with excellence.",
    callUs: 'Call Us',
    location: 'Location',
    socialMedia: 'Social Media',
    followUs: 'Follow us on Instagram',
    followUsFacebook: 'Follow us on Facebook',
    readyToOrder: 'Ready to Order?',
    orderDescription: 'Contact us today to discuss your fruit supply needs. We deliver quality and excellence in every order.',
    callNow: 'Call Now',
    
    // Footer
    quickLinks: 'Quick Links',
    contactInformation: 'Contact Information',
    allRightsReserved: 'All rights reserved',
    established: 'Established',
  },
  ar: {
    // Header
    home: 'الرئيسية',
    about: 'عن الشركة',
    products: 'المنتجات',
    contact: 'اتصل بنا',
    
    // Hero
    companyName: 'الحنادس',
    tagline: 'الجودة والتميز في كل قضمة',
    heroDescription: 'نستورد أفضل أنواع الفواكه من جميع أنحاء العالم إلى العراق منذ عام 2023',
    getInTouch: 'تواصل معنا',
    
    // About
    aboutTitle: 'عن الحنادس',
    aboutDescription: 'مرحباً بكم في الحنادس، المستورد الرائد للفواكه الممتازة من جميع أنحاء العالم. يقع مقرنا في العراق، ونختص في جلب الفواكه الطازجه ب اعلى جودة إلى الأسواق المحلية. مهمتنا هي تزويد عملائنا بمجموعة متنوعة من الفواكه الغريبة واللذيذة، مع ضمان أعلى جودة ونضارة. نتطلع إلى توسيع آفاقنا ومشاركة فواكهنا الاستثنائية مع الأسواق الدولية، بما في ذلك أوروبا والخليج العربي. في شركة الحنادس، نحن ملتزمون بالجودة والاستدامة والتميز في كل خطوة من رحلتنا.',
    
    // Features
    globalSourcing: 'التوريد العالمي',
    globalSourcingDesc: 'نستورد الفواكه من أفضل المناطق حول العالم، مما يضمن الجودة والنضارة.',
    seasonalVariety: 'تنوع موسمي',
    seasonalVarietyDesc: 'يتكيف اختيار منتجاتنا مع المواسم، لنقدم لكم أطازج الفواكه على مدار العام.',
    qualityAssured: 'جودة مضمونة',
    qualityAssuredDesc: 'يتم فحص كل فاكهة بعناية وتخزينها في ظروف مثالية للحفاظ على النضارة.',
    reliableDistribution: 'توزيع موثوق',
    reliableDistributionDesc: 'مع سنوات من الخبرة، نضمن التوصيل في الوقت المحدد وخدمة ممتازة لعملائنا.',
    
    // Products
    productsTitle: 'منتجاتنا المميزة',
    productsDescription: 'نحصل على الفواكه الموسمية من أفضل المناطق في العالم، لضمان جودة ونضارة استثنائية في كل عملية توصيل.',
    freshStrawberries: 'فراولة طازجة',
    strawberriesDesc: 'فراولة ممتازة الجودة، يتم اختيارها بعناية واستيرادها طازجة.',
    goldenApples: 'تفاح ذهبي',
    goldenApplesDesc: 'تفاح ذهبي حلو ومقرمش، يتم الحصول عليه من أفضل البساتين في العالم.',
    peachesApricots: 'خوخ ومشمش',
    peachesDesc: 'خوخ ومشمش غني بالعصارة، مثالي للموسم، مخزن بعناية.',
    redApples: 'تفاح أحمر ممتاز',
    redApplesDesc: 'تفاح أحمر عالي الجودة، معبأ بعناية ومخزن في ظروف مثالية.',
    greenGrapes: 'عنب أخضر طازج',
    grapesDesc: 'عنب أخضر حلو، معبأ باحتراف وجاهز للتوزيع.',
    premiumMangoes: 'مانجو ذهبي ممتاز',
    premiumMangoesDesc: 'مانجو ذهبي حلو وعصير، يتم اختياره بعناية ويُلف بشكل فردي لضمان الجودة الممتازة.',
    seasonalSelection: 'اختيار موسمي',
    seasonalInfo: 'تتنوع مجموعة منتجاتنا مع المواسم لنقدم لكم أطازج الفواكه في ذروتها. نقوم بتحديث مخزوننا باستمرار بناءً على التوافر الموسمي ومعايير الجودة.',
    
    // Categories
    berries: 'توت',
    apples: 'تفاح',
    stoneFruits: 'فواكه حجرية',
    grapes: 'عنب',
    
    // Contact
    contactTitle: 'تواصل معنا',
    contactDescription: 'اتصل بنا اليوم للحصول على فواكه ممتازة الجودة. نحن هنا لخدمتكم بتميز.',
    callUs: 'اتصل بنا',
    location: 'الموقع',
    socialMedia: 'وسائل التواصل',
    followUs: 'تابعونا على إنستغرام',
    followUsFacebook: 'تابعونا على فيسبوك',
    readyToOrder: 'جاهز للطلب؟',
    orderDescription: 'اتصل بنا اليوم لمناقشة احتياجاتك من إمدادات الفواكه. نحن نقدم الجودة والتميز في كل طلب.',
    callNow: 'اتصل الآن',
    
    // Footer
    quickLinks: 'روابط سريعة',
    contactInformation: 'معلومات الاتصال',
    allRightsReserved: 'جميع الحقوق محفوظة',
    established: 'تأسست',
  },
};
